import http from 'plugins/axios';

export default {
  getUserBillList(data) {
    return http.get({
      url: '/la/admin/select/tx/all',
      data
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/all'
    });
  }
  // getUserinfo() {
  //   return http.get({
  //     url: '/la/admin/u/infos'
  //   });
  // }
};
